import useDebounce from "hooks/others/useDebounce";
import { WorkScheduleReportModel } from "models/workSchedule";
import { useQuery } from "react-query";
import { GetEmployeeWorkReports } from "services/workSchedule";
import { ApiError } from "utils/api/models/api-error";
import ApiResult from "utils/api/models/api-result";

export default function UseGetEmployeeWorkReports(
    page: number,
    perPage: number
) {
    const queryKey = ["employee-work-reports", page, perPage];
    return {
        ...useQuery<ApiResult<WorkScheduleReportModel[]>, ApiError>(
            queryKey,
            () => GetEmployeeWorkReports(page, perPage),
        )   
    }
}